<template>
	<div class="">
		<div class="center">
			<img src="@/assets/banner.jpg" alt="banner" height="550">
			<login-form :isManager="isManager"></login-form>
		</div>
	</div>
</template>

<script>
import LoginForm from "@/components/login/LoginForm";

export default {
	name: "login",
	data() {
		return {};
	},
	computed: {
		isManager() {
			return this.$route.query.manager
				&& JSON.parse(this.$route.query.manager)
				|| false;
		}
	},
	methods: {},
	created() { },
	mounted() { },
	components: {
		LoginForm
	}
};
</script>

<style lang='scss' scoped>
</style>